
import { depListAPI } from '@/api/common';
import PinyinMatch from 'pinyin-match';

export default {
  name: 'XhStructure', // 新建 structure
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 多选框 只能选一个
    radio: {
      type: Boolean,
      default: false
    },
    // 已选信息
    selectedData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      breadcrumbList: [], // 面包屑数据
      selectItems: [], // 选择项
      dataList: [], // 展示数据
      loading: false, // 加载动画
      searchInput: ''
    };
  },

  computed: {
    showDataList: function showDataList() {
      var _this = this;

      return this.dataList.filter(function (item) {
        return PinyinMatch.match(item.name, _this.searchInput);
      });
    }
  },
  watch: {
    selectedData: function selectedData() {
      this.selectItems = this.selectedData;
      this.dataList = this.handelCheck(this.dataList);
    },
    show: function show(value) {
      if (this.dataList && this.dataList.length == 0) {
        this.getStructureList();
      }
    }
  },
  mounted: function mounted() {
    this.selectItems = this.selectedData;
    if (this.show) {
      this.getStructureList();
    }
  },

  methods: {
    /**
     * 部门列表数据
     */
    getStructureList: function getStructureList() {
      var _this2 = this;

      this.loading = true;
      depListAPI({
        type: 'tree'
      }).then(function (res) {
        var allList = _this2.handelCheck(_this2.addIsCheckProp(res.data));
        _this2.dataList = allList;
        _this2.breadcrumbList.push({ label: '全部', data: allList });

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },


    /**
     * 面包屑点击事件
     */
    breadcrumbBtn: function breadcrumbBtn(item, index) {
      if (this.radio && this.selectItems.length == 1) return;
      if (index + 1 <= this.breadcrumbList.length - 1) {
        this.breadcrumbList.splice(index + 1, this.breadcrumbList.length - 1);
      }
      this.dataList = [];
      this.dataList = this.handelCheck(item.data);
    },


    /**
     * 点击checkbox选中
     */
    checkChange: function checkChange(item, aindex) {
      this.$set(this.dataList, aindex, item);
      var removeIndex = -1;
      for (var index = 0; index < this.selectItems.length; index++) {
        var element = this.selectItems[index];
        if (item.id == element.id) {
          removeIndex = index;
        }
      }
      if (removeIndex == -1 && item.isCheck) {
        this.selectItems.push(item);
      } else if (removeIndex != -1) {
        this.selectItems.splice(removeIndex, 1);
      }

      // 单选逻辑
      if (this.radio) {
        if (item.isCheck) {
          this.dataList = this.dataList.map(function (element, index, array) {
            if (element.id == item.id) {
              element.disabled = false;
            } else {
              element.disabled = true;
            }
            return element;
          });
        } else {
          this.dataList = this.dataList.map(function (item, index, array) {
            item.disabled = false;
            return item;
          });
        }
      }

      this.$emit('changeCheckout', this.selectItems);
    },


    /**
     * 数据重新刷新时 循环标记展示数组
     */
    handelCheck: function handelCheck(list) {
      var _this3 = this;

      var disabled = false;
      if (this.radio) {
        // 如果有勾选其他为false
        disabled = this.selectItems.length > 0;
      }

      list = list.map(function (item, index, array) {
        item.isCheck = _this3.selectItemsHasItem(item);
        if (_this3.radio && item.isCheck) {
          item.disabled = false;
        } else {
          item.disabled = disabled;
        }
        return item;
      });
      return list;
    },
    selectItemsHasItem: function selectItemsHasItem(item) {
      if (this.selectItems.length == 0) {
        return false;
      }
      var hasItem = false;
      for (var index = 0; index < this.selectItems.length; index++) {
        var element = this.selectItems[index];
        if (item.id == element.id) {
          hasItem = true;
          break;
        }
      }
      return hasItem;
    },


    /**
     * 点击进入子数组
     */
    enterChildren: function enterChildren(item) {
      // 保证单选环境下 没有选中 才可进入children
      if (item.children && !(this.radio && this.selectItems.length == 1)) {
        this.dataList = [];
        this.dataList = this.handelCheck(this.addIsCheckProp(item.children));
        this.breadcrumbList.push({ label: item.label, data: this.dataList });
      }
    },


    /**
     * 给默认数据加isCheck属性
     */
    addIsCheckProp: function addIsCheckProp(list) {
      if (list.length > 0) {
        var item = list[0];
        if (item.hasOwnProperty('isCheck')) {
          return list;
        } else {
          return list.map(function (item, index, array) {
            item.disabled = false;
            item.isCheck = false;
            item.show = true;
            return item;
          });
        }
      }
      return list;
    },
    clearAll: function clearAll() {
      this.selectItems = [];
      this.dataList = this.dataList.map(function (item) {
        item.isCheck = false;
        return item;
      });
      this.$emit('changeCheckout', this.selectItems);
    }
  }
};